export interface SideNav {
  isCollapsed: boolean;
}

export const initialState: SideNav = {
  isCollapsed: false,
};
